<div
  class="form-field-container"
  appFocusOut
  (elementFocusOut)="showCalender = false"
>
  <div [ngClass]="labelTextTransformNone ? 'input-field-name-none': 'input-field-name'" *ngIf="labelName && showLabelName; else noLabel">
    {{ labelName}}
    <span *ngIf="tooltiptxt" [ngbTooltip]=tooltiptxt placement="right" >
      <em
      class="fa fa-info-circle info-icon"
    ></em></span>
    <span class="optional" *ngIf="!isRequiredField && showOptionalLabel">({{ OPTIONAL }})</span>
  </div>
  <ng-template #noLabel>
    <br *ngIf="showNoLabel" />
  </ng-template>
  <div *ngIf="readOnlyMode" class="readOnly">{{ inputFormControl.value }}</div>
  <input
    *ngIf="!readOnlyMode"
    type="text"
    #inputBox
    [ngClass]="getClasses()"
    [formControl]="inputFormControl"
    placeholder="{{ placeHolder }}"
    (focus)="focusFunction()"
    (focusout)="focusOutFunction()"
  />
  <div *ngIf="showCommentIcon" class="comment-icon">
    <app-button *ngIf="!isGradeTable" [type]="(commentObject && commentObject.value && commentObject.value.length) ? 'commented-icon' : 'comment-icon' " (btnClick)="clickComment()"></app-button>
    <app-button *ngIf="isGradeTable" [type]="(commentObject && commentObject.length) ? 'commented-icon' : 'comment-icon' " (btnClick)="clickComment()" [disable]="disableComments"></app-button>
  </div>
  <span
    [ngClass]="showCommentIcon ? 'calender-icon calender-icon-comment' : 'calender-icon'"
    [hidden]="!showDatePicker"
    (click)="showCalender = !showCalender"
  >
    <i class="fa fa-calendar-o" aria-hidden="true"></i>
  </span>
  <ngb-datepicker
    #dp
    [ngClass]="showCommentIcon ? 'calender-container calender-container-comment' : 'calender-container'"
    [(ngModel)]="datePickermodel"
    [minDate]="minDate"
    [maxDate]="maxDate"
    (ngModelChange)="onDateSelect($event)"
    [hidden]="!showCalender"
    (navigate)="date = $event.next"
    [disabled]="inputFormControl.disabled"
  ></ngb-datepicker>

  <div
    [ngClass]="labelTextTransformNone ? 'error-none': 'error'"
    *ngIf="
      inputFormControl &&
      !readOnlyMode &&
      (submitted || inputFormControl.touched) &&
      inputFormControl.errors
    "
  >
    <div *ngIf="inputFormControl.errors.required && labelName">
      {{ labelName }} is required.
    </div>
    <div *ngIf="showRequiredFieldWithoutLabel && inputFormControl.errors.required">
      {{ showRequiredFieldWithoutLabel }} is required.
    </div>
    <div *ngIf="inputFormControl.errors.email">
      Please provide a valid email address.
    </div>
    <div *ngIf="inputFormControl.errors.invalidPhoneNumber">
      Please provide a valid contact number.
    </div>
    <div *ngIf="inputFormControl.errors.invalidDate">
      Please provide a valid date format(DD/MM/YYYY).
    </div>
    <div *ngIf="inputFormControl.errors.invalidDateRange">
      Date should not be a future date.
    </div>
    <div *ngIf="inputFormControl.errors.invalidMinDate">
      Date should not be less than 02/01/1753.
    </div>
    <div *ngIf="inputFormControl.errors.invalidTextMax4">
      {{ labelName }} should not exceed 4 characters.
    </div>
    <div *ngIf="inputFormControl.errors.invalidTextMax5">
      {{ labelName }} should not exceed 5 characters.
    </div>
    <div *ngIf="inputFormControl.errors.invalidTextMax20">
      {{ labelName }} should not exceed 20 characters.
    </div>
    <div *ngIf="inputFormControl.errors.invalidTextMax30">
      {{ labelName }} should not exceed 30 characters.
    </div>
    <div *ngIf="inputFormControl.errors.invalidTextMax50">
      {{ labelName }} should not exceed 50 characters.
    </div>
    <div *ngIf="inputFormControl.errors.invalidTextMax100">
      {{ labelName }} should not contain more than 100 characters.
    </div>
    <div *ngIf="inputFormControl.errors.invalidTextMax200">
      {{ labelName }} should not contain more than 200 characters.
    </div>
    <div *ngIf="inputFormControl.errors.invalidTextMax500">
      {{ labelName }} should not contain more than 500 characters.
    </div>
    <div *ngIf="inputFormControl.errors.invalidTextMax1000">
      {{ labelName }} should not contain more than 1000 characters.
    </div>
    <div *ngIf="inputFormControl.errors.invalidTextMax1500">
      {{ labelName }} should not contain more than 1500 characters.
    </div>
    <div *ngIf="inputFormControl.errors.invalidSpecialSymbol">
      {{ labelName }} should not contain symbols.
    </div>
    <div *ngIf="inputFormControl.errors.invalidNumber">
      {{ labelName }} should only contain numerical values.
    </div>
    <div *ngIf="inputFormControl.errors.invalidPercentageRange">
      {{ labelName }} should not exceed 100.
    </div>
    <div *ngIf="inputFormControl.errors.invalidInteger">
      {{ labelName }} should only contain integer values.
    </div>
    <div *ngIf="inputFormControl.errors.invalidNumber100">
      {{ labelName }} should not exceed 100.
    </div>
    <div *ngIf="inputFormControl.errors.invalidTextMax300">
      {{ labelName }} should not contain more than 300 characters.
    </div>
    <div *ngIf="inputFormControl.errors.invalidNumber999999">
      {{ labelName }} should not exceed 999999.
    </div>
    <div *ngIf="inputFormControl.errors.invalidNumber99999">
      {{ labelName }} should not exceed 99999.
    </div>
    <div *ngIf="inputFormControl.errors.invalidNumber999">
      {{ labelName }} should not exceed 999.
    </div>
    <div *ngIf="inputFormControl.errors.invalidNumber9999">
      {{ labelName }} should not exceed 9999.
    </div>


    <div *ngIf="inputFormControl.errors.invalidNumber2147483647">
      {{ labelName }} should not exceed 2147483647.
    </div>
    <div *ngIf="inputFormControl.errors.invalidDeciamlNumber2">
      {{ labelName }} should not exceed 2 decimal places.
    </div>
    <div *ngIf="inputFormControl.errors.invalidDeciamlNumber6">
      {{ labelName }} should not exceed 6 decimal places.
    </div>
    <div *ngIf="inputFormControl.errors.invalidFromToDate">
      Please enter an End date that is after Start date.
    </div>
    <div *ngIf="inputFormControl.errors.invalidAlphabetSpecial">
      {{ labelName }} should allow only alphabets and special characters.
    </div>
    <div *ngIf="inputFormControl.errors.onlyNumberNotAllow">
      {{ labelName }} should not be numerical value.
    </div>
    <div *ngIf="inputFormControl.errors.numberAllowRatioBtn1to10">
      Ratio should be between 1 and 10.
    </div>
    <div *ngIf="inputFormControl.errors.numberAllowRatioBtn0to10">
      Ratio should be between 0 and 10.
    </div>
    <div *ngIf="inputFormControl.errors.invalidNegativeNumber">
      Value cannot be negative.
    </div>
    <div *ngIf="inputFormControl.errors.htmlTagError">
      {{ labelName }} do not allow HTML TAGS.
    </div>
  </div>
</div>
